import React from 'react';
import { ArrowRight, ThermometerSnowflake, Snowflake, Fan, Droplets, Power, Volume2 } from 'lucide-react';

const problems = [
  { title: 'AC Blowing Warm Air', href: '/ac-blowing-warm-air', icon: ThermometerSnowflake, color: 'text-red-500', bg: 'bg-red-50' },
  { title: 'AC Freezing Up', href: '/ac-freezing-up', icon: Snowflake, color: 'text-blue-500', bg: 'bg-blue-50' },
  { title: 'Not Cooling', href: '/ac-running-but-not-cooling', icon: Fan, color: 'text-orange-500', bg: 'bg-orange-50' },
  { title: 'Leaking Water', href: '/ac-leaking-water', icon: Droplets, color: 'text-cyan-500', bg: 'bg-cyan-50' },
  { title: 'Won\'t Turn On', href: '/ac-not-turning-on', icon: Power, color: 'text-slate-600', bg: 'bg-slate-100' },
  { title: 'Loud Noises', href: '/ac-making-loud-noise', icon: Volume2, color: 'text-purple-500', bg: 'bg-purple-50' },
];

const CommonProblemsStrip = () => {
  return (
    <section className="py-16 bg-slate-50" data-testid="common-problems-strip">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 gap-4">
          <div>
            <h2
              className="text-3xl md:text-4xl font-bold text-[#0F172A]"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Common AC Problems
            </h2>
            <p className="text-slate-500 mt-1">Troubleshoot your issue or learn when it's time to replace.</p>
          </div>
          <a
            href="/common-ac-problems"
            className="inline-flex items-center gap-1.5 text-[#0EA5E9] font-semibold text-sm hover:underline flex-shrink-0"
            data-testid="view-all-problems-link"
          >
            View all problems
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {problems.map((p, i) => (
            <a
              key={i}
              href={p.href}
              data-testid={`problem-strip-${i}`}
              className="group flex flex-col items-center text-center p-4 bg-white rounded-xl border border-slate-200 hover:border-[#0EA5E9] hover:shadow-md transition-all duration-300"
            >
              <div className={`w-10 h-10 ${p.bg} rounded-lg flex items-center justify-center mb-3`}>
                <p.icon className={`w-5 h-5 ${p.color}`} />
              </div>
              <span className="text-sm font-semibold text-[#0F172A] group-hover:text-[#0EA5E9] transition-colors">
                {p.title}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommonProblemsStrip;
